import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';

import { CommonModule, SlicePipe } from '@angular/common';
import { BaseRules, TextValues } from './georgia.model';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { CardModule, CheckboxModule, DropdownModule, RadioButtonModule, AlertModule, TooltipModule } from 'axis-components';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-georgia',
  templateUrl: './georgia.component.html',
  styleUrls: ['./georgia.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    CommonModule,
    TruncateModule,
    TooltipModule
  ]
})
export class GeorgiaComponent extends UimuiBaseStateComponent<BaseRules, TextValues> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('georgia', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('georgia', null);
    }
  }
}
